 export const BASE_URL = "https://cpcentral.paramount.com/"; //PROD
 //export const BASE_URL = "https://cpcentral-uat.paramount.com/";
//export const BASE_URL = "https://cpcentral-dev.paramount.com/";
// export const BASE_URL = "https://cpcentral-qa.paramount.com/";
// export const BASE_URL = "https://localhost:7073/";
export const environment = {
  applicationName: "CP Central",
  // googleCaptchaKey: "6LcLi70UAAAAACfKwy42EQz5BLyb_V5Gboq82zwq", //dev
  googleCaptchaKey: "6LdvaUgsAAAAAHfvstNeUwUjAQ50BT_GZpCGRX8k", //dev
  oktaClientId: "0oa209zm279jKsXpV1d8", //prod
  //oktaClientId: "0oa1z7dsknvgA4AL31d8", //dev
   //oktaClientId: "0oa1zquvoscfqJsUp1d8", //qa
  apiBaseUrl: `${BASE_URL}API/api/`, // api
  // apiBaseUrl: `${BASE_URL}api/`, // api
  // apiBaseUrl: "http://cpcentral-dev.paramount.com/API/api/", // api

  createdByUpdatedById: 4,

  // communityRedirectUrl: "https://www.google.com/",
  //apiBaseUrl:'http://msrcpcpmappdv01:8080/api/' // -- Deployed site-Dev
  // apiBaseUrl:'http://cpam-uat.paramount.com/cpamapi/api/' // -- Deployed site-Dev

  licenseMaestroFormUrl:
    "https://my.paramount.com/esc?id=sc_cat_item&sys_id=74c9acd51bd4649841f599f4bd4bcb3b", // License Maestro URL
};
